import React, { useEffect, useState } from "react"
import { useAsyncDebounce } from "react-table"
import "./table.scss"

// @ts-ignore
export const GlobalFilter = ({ filter, setFilter }) => {
  const [value, setValue] = useState(filter)
  useEffect(() => {
    setValue(filter)
  }, [filter])
  const onChange = useAsyncDebounce((value) => {
    setFilter(value || undefined)
    localStorage.setItem("globalFilterMaster", value)
    localStorage.setItem("globalFilterCenter", value)
    localStorage.setItem("globalFilterConsent", value)
  }, 1000)
  return (
    <div className="table-container">
      <input
        className="inputGlobalSearch"
        placeholder="Search"
        value={value || ""}
        onChange={(e) => {
          setValue(e.target.value.trimStart())
          onChange(e.target.value.trimStart())
        }}
      />
      <img
        src="../../assets/images/searchIcon.svg"
        alt=""
        style={{ marginLeft: "-50px", width: "26px", height: "26px" }}
      />
    </div>
  )
}
